/**
 * Project config helpers for optional ROI (regions of interest) guidance mode.
 * ROI rectangles live in a dedicated server annotation layer; types are defined in config.roi.roiCategories.
 */

/**
 * @param {object} [uiConfig] - annotationUI.config
 * @returns {{ enabled: boolean, categoryIds: string[], categoryId: string, roiCategories: Array<{id: string, label?: string, style?: object}>, adminRoiDrawingComplete: boolean }}
 */
export function getRoiConfig(uiConfig) {
    const roi = uiConfig?.roi ?? {};
    let roiCategories = [];
    if (Array.isArray(roi.roiCategories) && roi.roiCategories.length > 0) {
        roiCategories = roi.roiCategories;
    } else if (roi.categoryId != null && String(roi.categoryId).trim() !== '') {
        roiCategories = [{ id: String(roi.categoryId), label: 'ROI', style: {} }];
    }
    const categoryIds = roiCategories.map((c) => c?.id).filter(Boolean).map(String);
    const enabled = Boolean(roi.enabled && categoryIds.length > 0);
    return {
        enabled,
        categoryIds,
        categoryId: categoryIds[0] || '',
        roiCategories,
        adminRoiDrawingComplete: Boolean(roi.adminRoiDrawingComplete),
    };
}

/**
 * @param {string} categoryId
 * @param {{ roiCategories: Array<{ id: string, label?: string }> }} roiConfig
 */
export function getRoiTypeLabel(categoryId, roiConfig) {
    const id = categoryId != null ? String(categoryId) : '';
    const list = roiConfig?.roiCategories ?? [];
    const row = list.find((c) => String(c.id) === id);
    return (row?.label || id || 'Region').trim() || 'Region';
}

/**
 * Categories used for drawing, review lanes, and completion checks (excludes ROI types when ROI mode is on).
 * @param {Array<{ id: string }>} categories
 * @param {{ enabled: boolean, categoryIds: string[] }} roiConfig
 */
/** True if the project has at least one ROI type defined (for admin ROI editor entry). */
export function hasRoiTypesConfigured(uiConfig) {
    const r = uiConfig?.roi ?? {};
    if (Array.isArray(r.roiCategories) && r.roiCategories.length > 0) return true;
    if (r.categoryId != null && String(r.categoryId).trim() !== '') return true;
    return false;
}

export function filterTaskCategories(categories, roiConfig) {
    const list = categories ?? [];
    const idSet = new Set(roiConfig?.categoryIds ?? []);
    if (!roiConfig?.enabled || idSet.size === 0) return list;
    return list.filter((c) => !idSet.has(c.id));
}
